import { breakpoints, screen } from "./grid.js";
import { palette } from "./palette.js";
import { spacers, spacer } from "./spacers.js";
const theme = {
  spacer,
  spacers,
  palette,
  screen,
  breakpoints
};
export {
  theme
};
//# sourceMappingURL=index.js.map
